import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const availableLanguages = ["es", "en", "pt"];

i18n
  .use(HttpApi) // load translations using http
  .use(LanguageDetector) // detect user language
  .use(initReactI18next) // pass the i18n instance to react-i18next.
  .init({
    backend: {
      // loadPath: '/src/assets/locales/{{lng}}/translation.json', // Ruta de archivos de traducción en src
      loadPath: process.env.REACT_APP_TRANSLATION_I18N, // Ruta de archivos de traducción en src
    },
    fallbackLng: "es",
    keySeparator: undefined,
    detection: {
      order: ["queryString", "cookie"],
      cache: ["cookie"],
    },

    debug: false,

    whitelist: availableLanguages,

    interpolation: {
      escapeValue: false, // no need for react. it escapes by default
    },
  });

export default i18n;
